import { fruitCategoriesIdNameQuery } from "types/agriculture/sale-types";
import { InputCostumeErrorType } from "types/form-types";
import FruitClassificationMultiselectInput, { ClassificationType, FruitClassificationMultiselectInputPropsType } from "./FruitClassificationMultiselectInput";

type FruitCategoryMultiselectInputPropsType = {
    fruitId: string | undefined | null | number | false,
    value?: ClassificationType[],
    onChange?: (s: ClassificationType[] | undefined, event: React.MouseEvent | React.KeyboardEvent | React.FocusEvent) => void,
    min?: number,
    max?: number,
    customErrors?: InputCostumeErrorType<ClassificationType[], HTMLInputElement>[],
    required?: boolean
    name?: string
    label?: string
}

const FruitCategoryMultiselectInput = (props: FruitCategoryMultiselectInputPropsType) => {    
    const fruitCategoryMultiselectSettings: FruitClassificationMultiselectInputPropsType = {
        fruitId: props.fruitId,
        queryData: {
            query: fruitCategoriesIdNameQuery,
            field: "fruitCategories"
        },
        label: props.label || 'fields.category.name',
        name: props.label || "fruitCategory",
        onChange: props.onChange,
        customErrors: props.customErrors,
        max: props.max,
        min: props.min,
        required: props.required
    };
    
    return (
        <FruitClassificationMultiselectInput
            {...fruitCategoryMultiselectSettings}
            value={props.value}
        />
    );
};

export default FruitCategoryMultiselectInput;
